<template>
  <section>
    <div class="wrap">
      <SectionTitle :title="title" subTitle="サービス" :black="true" />
      <div class="services">
        <div class="service">
          <img src="@/assets/usedcar/service_01.webp" alt="中古車販売・買取">
          <h3>中古車の販売</h3>
          <div class="service-link animation-btn bgskew" v-scroll-to="'#used-car'"><span>詳細を見る</span></div>
        </div>
        <div class="service">
          <img src="@/assets/usedcar/service_02.webp" alt="保険(自動車保険/損害保険/生命保険)">
          <h3>オークション代行</h3>
          <div class="service-link animation-btn bgskew" v-scroll-to="'#auction'"><span>詳細を見る</span></div>
        </div>
        <div class="service">
          <img src="@/assets/usedcar/service_03.webp" alt="レンタカー">
          <h3>自動車買取</h3>
          <div class="service-link animation-btn bgskew" v-scroll-to="'#purchase'"><span>詳細を見る</span></div>
        </div>
        <div class="service">
          <img src="@/assets/usedcar/service_04.webp" alt="車検・自動車整備">
          <h3>新車販売</h3>
          <div class="service-link animation-btn bgskew" v-scroll-to="'#new-car'"><span>詳細を見る</span></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from '@/components/Ui/SectionTitle.vue';

export default {
  name: "OurService",
  components: {
    SectionTitle,
  },
  data() {
    return {
      title: "Our Services",
      description: true,
    }
  },
}
</script>

<style lang="scss" scoped>
section {
  background-color: var(--main);
  .wrap {
    .services {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .service {
        position: relative;
        width: 47%;
        height: 540px;
        @media screen and (min-width: 768px) and (max-width: 1100px) {
          height: 420px;
        }
        @media screen and (max-width: 767px) {
          width: 100%;
          height: 430px;
        }
        h3 {
          font-size: 23px;
          color: var(--white);
          text-align: center;
          margin: 30px 0;
          @media screen and (max-width: 1100px) {
            font-size: 20px;
          }
        }
        .service-link {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60%;
          height: 60px;
          margin: auto;
          color: var(--white);
          border: 1px solid var(--white);
          cursor: pointer;
          &:hover {
            color: var(--main);
          }
        }
      }
    }
  }
}
</style>